"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// Generated from ../../../cs/src/Contracts/TunnelReportProgressEventArgs.cs
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelProgress = void 0;
/**
 * Specifies the tunnel progress events that are reported.
 */
var TunnelProgress;
(function (TunnelProgress) {
    /**
     * Starting refresh ports.
     */
    TunnelProgress["StartingRefreshPorts"] = "StartingRefreshPorts";
    /**
     * Completed refresh ports.
     */
    TunnelProgress["CompletedRefreshPorts"] = "CompletedRefreshPorts";
    /**
     * Starting request uri for a tunnel service request.
     */
    TunnelProgress["StartingRequestUri"] = "StartingRequestUri";
    /**
     * Starting request configuration for a tunnel service request.
     */
    TunnelProgress["StartingRequestConfig"] = "StartingRequestConfig";
    /**
     * Starting to send tunnel service request.
     */
    TunnelProgress["StartingSendTunnelRequest"] = "StartingSendTunnelRequest";
    /**
     * Completed sending a tunnel service request.
     */
    TunnelProgress["CompletedSendTunnelRequest"] = "CompletedSendTunnelRequest";
    /**
     * Starting create tunnel port.
     */
    TunnelProgress["StartingCreateTunnelPort"] = "StartingCreateTunnelPort";
    /**
     * Completed create tunnel port.
     */
    TunnelProgress["CompletedCreateTunnelPort"] = "CompletedCreateTunnelPort";
    /**
     * Starting get tunnel port.
     */
    TunnelProgress["StartingGetTunnelPort"] = "StartingGetTunnelPort";
    /**
     * Completed get tunnel port.
     */
    TunnelProgress["CompletedGetTunnelPort"] = "CompletedGetTunnelPort";
})(TunnelProgress = exports.TunnelProgress || (exports.TunnelProgress = {}));
//# sourceMappingURL=tunnelProgress.js.map